<template>
  <div>
    <autopayment-modal v-if="modalIsVisible" :onCloseModal="() => { modalIsVisible=false }" :is-visible="modalIsVisible" />
    <div class="container-fluid">
      <div class="invoice row">
        <card>
          <div class="card__title">
            <h4>{{ $t('Payments') }}</h4>
          </div>
          <div class="card__body">
            <div v-if="loading" v-loading="loading" class="fullscreen-loading" />
            <div v-else>
              <div class="tools">
                <el-radio-group v-model="currentTab" size="medium" v-if="paymentEnabled">
                  <el-radio-button :label="0">Список платежей</el-radio-button>
                  <el-radio-button :label="1">Автоплатежи</el-radio-button>
                </el-radio-group>
                <el-button v-if="currentTab === 1" type="primary" @click="openModal" size="small" round plain >{{$t('Create')}}</el-button>
              </div>
              <payments-table v-if="currentTab === 0"/>
              <autopayments-table v-if="currentTab === 1"/>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentsTable from './PaymentsTable'
import AutopaymentsTable from './AutopaymentsTable'
import AutopaymentModal from './AutopaymentModal'
import number from './mixins/number'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  name: 'Payments',
  mixins: [number],
  data () {
    return {
      currentTab: 0,
      modalIsVisible: false,
      loading: true,
      modal: {
        agreements: [],
        agreement: null,
        sum: null,
        email: '',
        dayOfMonth: 1,
        period: 1,
        paymentId: null,
        opened: false,
        loading: false
      }
    }
  },
  components: {
    'payments-table': PaymentsTable,
    'autopayments-table': AutopaymentsTable,
    'autopayment-modal': AutopaymentModal
  },
  mounted () {
    this.loading = true
    this.$store.dispatch('getAllEpsProviders')
    this.$store.dispatch('getProfile').then(() => {
      this.loading = false
    })
  },
  computed: {
    ...mapState({
      config: state => state.config.data,
      profile: state => state.profile.credentials,
      providers: state => state.epsProviders.all
    }),
    paymentEnabled: function() {
      const hasYookassa = this.providers.findIndex(item => item.slug === 'yookassa')

      if (hasYookassa < 0) {
        return false
      }
      if (this.profile.type === 1 && this.config.disableLegalEntityPayments) {
        return false
      }
      return true
    }
  },
  methods: {
    openModal() {
      this.modalIsVisible = true
    },
    getAgreements: function() {
      axios.get('agreements').then(promise => {
        this.modal.agreements = promise.data.results
        if (!this.modal.agreement && promise.data.results.length > 1) {
          this.modal.agreement = promise.data.results[0].id
        }
      })
    },
    getError(fieldName) {
      return this.$t(this.errors.first(fieldName))
    }
  }
}

</script>

<style scoped>
  #hiddenDownloader {
    display: none
  }
  .orders-table {
    margin-bottom: 10px;
  }
  .orders-pagination >>> .el-input__inner {
    margin: 0 !important;
  }
  .orders-pagination >>> .el-input {
    width: 140px !important;
  }
  .tools {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .agreement-select {
    width: 100%;
    margin-bottom: 10px;
  }
</style>
